import script from "./ShoppingDetailPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingDetailPage2.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingDetailPage2.vue?vue&type=style&index=0&id=21142f86&scoped=true&lang=scss"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21142f86"]])

export default __exports__